'use strict';

const encoders = exports;

encoders.der = require('./der');
encoders.pem = require('./pem');



//////////////////
// WEBPACK FOOTER
// ./~/_asn1.js@5.4.1@asn1.js/lib/asn1/encoders/index.js
// module id = 213
// module chunks = 0